module.exports = __webpack_public_path__ + "img/client12.7ad8c793.jpeg";